export default "__VITE_ASSET__BY3AYCq6__"